/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_Envelope_TitleInputs */

const en_directory_api_reference_envelope_title = /** @type {(inputs: Directory_Api_Reference_Envelope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response envelope`)
};

const zh_directory_api_reference_envelope_title = /** @type {(inputs: Directory_Api_Reference_Envelope_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`响应信封`)
};

/**
* | output |
* | --- |
* | "Response envelope" |
*
* @param {Directory_Api_Reference_Envelope_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_envelope_title = /** @type {((inputs?: Directory_Api_Reference_Envelope_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_Envelope_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_envelope_title(inputs)
	return zh_directory_api_reference_envelope_title(inputs)
});
export { directory_api_reference_envelope_title as "directory.api_reference.envelope_title" }